import { Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { ShopSidebarService } from 'src/app/shared/services/shop-sidebar.service';
import {  Subject } from 'rxjs';
import {  map, takeUntil } from 'rxjs/operators';
import { fromMatchMedia } from 'src/app/shared/functions/rxjs/fromMatchMedia';
import { RootService } from 'src/app/shared/services/root.service';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
    selector: 'app-shop-sidebar',
    templateUrl: './shop-sidebar.component.html',
    styleUrls: ['./shop-sidebar.component.sass']
})
export class ShopSidebarComponent implements OnInit, OnDestroy {

    destroy$: Subject<void> = new Subject<void>();
    isOpen = false;
    @Input() public filters: [];
    

    constructor(
        public sidebar: ShopSidebarService,
        public root: RootService,
        
    ) { }

    ngOnInit(): void {
        this.sidebar.isOpen$.pipe(
            takeUntil(this.destroy$)
        ).subscribe(isOpen => {
            if (isOpen) {
                this.open();
            } else {
                this.close();
            }
        });


        fromMatchMedia('(max-width: 991px)').pipe(takeUntil(this.destroy$)).subscribe(media => {
            if (this.isOpen && !media.matches) {
                this.close();
            }
        });
        // this.pageCategory.list$.pipe(
        //     map(x => x.filters),
        //     takeUntil(this.destroy$),
        // ).subscribe(filters => {
        //     this.filters = filters;
        // });
    }

    ngOnDestroy(): void {
        this.close();
        this.destroy$.next();
        this.destroy$.complete();
    }

    private open(): void {
        const bodyWidth = document.body.offsetWidth;
            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = (document.body.offsetWidth - bodyWidth) + 'px';
        this.isOpen = true;
    }

    private close(): void {
        document.body.style.overflow = '';
            document.body.style.paddingRight = '';
        this.isOpen = false;
    }    
}
